import { Wifi, WifiOff } from "lucide-react"
import { useTheme } from "../../contexts/ThemeContext"
import { navigateTo } from "../../utils/navigation"
import useTranslation from "../../hooks/useTranslation"

export default function NoInternetScreen() {
  const { primaryColor } = useTheme()
  const { t, currentLanguage } = useTranslation()

  const handleRetry = () => {
    // Try to reload the page or navigate back
    window.location.reload()
  }

  const handleGoHome = () => {
    navigateTo("home")
  }

  return (
    // خلفية بيضاء مع تدرج خفيف مثل Figma
    <div className="min-h-screen w-full bg-gradient-to-b from-gray-50 via-white to-white relative flex items-center justify-center px-4">

   

      {/* الكارد الأبيض */}
      <div className="w-full max-w-sm rounded-3xl ">
        <div className="px-6 pt-10 pb-8 text-center">

          {/* أيقونة WiFi مع علامة X */}
          <div className="mx-auto mb-8 relative grid place-items-center">
            <div className="h-16 w-16 mx-auto flex items-center justify-center text-gray-400 relative">
              <Wifi className="w-12 h-12" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-16 h-16 border-4 border-gray-300 rounded-full"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-sm">
                    <WifiOff className="w-4 h-4 text-gray-400" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          
          {/* الرسالة التوضيحية */}
          <p className="mb-10 text-base text-gray-500 font-['IBM_Plex_Sans_Arabic'] leading-relaxed">
          {t('errors.noInternet')}
            {t('errors.noInternetMessage')}
          </p>

     
        </div>
      </div>
    </div>
  )
}
